import React, { FC } from 'react';
import { IconButton, Popover, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import { AllPlanScheduleType } from '@demind-inc/core';

import { SchedulerTaskPref } from '../../Scheduler/AIScheduler/SchedulerTaskPref';
import { SchedulerRoutineChatPref } from '../../Scheduler/AIScheduler/SchedulerRoutineChatPref';
import { AIAssistantMealSettings } from '../../SideBar/SettingsModal/AIAssistantSettings/AIAssistantMealSettings';
import { AIAssistantWorkoutSettings } from '../../SideBar/SettingsModal/AIAssistantSettings/AIAssistantWorkoutSettings';
import type { UseDailyPrefSchedulerChatReturn } from '../../../hooks/schedulerChat/types';
import './PlanTypeDetailDrawer.scss';

interface PlanTypeDetailDrawerProps {
  type: AllPlanScheduleType | null;
  label: string;
  anchorEl: HTMLElement | null;
  taskScheduler: UseDailyPrefSchedulerChatReturn;
  targetDate: string;
  onClose: () => void;
}

const PlanTypeDetailDrawer: FC<PlanTypeDetailDrawerProps> = ({
  type,
  label,
  anchorEl,
  taskScheduler,
  targetDate,
  onClose,
}) => {
  return (
    <Popover
      open={!!type && !!anchorEl}
      anchorEl={anchorEl}
      onClose={onClose}
      className="plan-type-detail-popover"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      slotProps={{
        paper: { className: 'plan-type-detail-popover__paper' },
      }}
    >
      <div className="plan-type-detail-popover__header">
        <Typography variant="subtitle2" fontWeight={700}>
          {label}
        </Typography>
        <IconButton size="small" onClick={onClose} aria-label="Close">
          <Close fontSize="small" />
        </IconButton>
      </div>
      <div className="plan-type-detail-popover__content">
        {type === 'todo' && (
          <SchedulerTaskPref
            tasks={taskScheduler.tasksPrefItems}
            onCheckTask={taskScheduler.onTaskSelection}
            onTaskChange={taskScheduler.onTaskChange}
            targetDate={targetDate}
            isLoading={taskScheduler.isPreferenceLoading}
          />
        )}
        {type === 'routine' && (
          <SchedulerRoutineChatPref
            routine={taskScheduler.routinePrefItem}
            isLoading={taskScheduler.isRoutineLoading}
            onRoutineCheckChange={taskScheduler.onRoutineSelection}
            onRoutineChange={taskScheduler.onRoutineChange}
            onRoutineAdd={taskScheduler.onRoutineAdd}
            onRoutineDelete={taskScheduler.onRoutineDelete}
            hasConfigured={false}
            fontSize="small"
            existingRoutineEvents={taskScheduler.existingRoutineEvents}
            scheduledRoutineActivityIds={taskScheduler.scheduledRoutineActivityIds}
          />
        )}
        {type === 'meal' && <AIAssistantMealSettings />}
        {type === 'workout' && <AIAssistantWorkoutSettings />}
        {type === 'sleep' && null}
      </div>
    </Popover>
  );
};

export default PlanTypeDetailDrawer;
